"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { User } from "lucide-react";
import Button from "@/components/ui/Button";
import LinkButton from "@/components/ui/Link";
import { DropdownMenu } from "@/components/layout/dropdownmenu/DropdownMenu";
import { buildDropdownItems } from "./dropdownItems";
interface Props {
  isLoggedIn: boolean;
  displayName: string;
  hasActiveSubscription: boolean;
  onLogout: () => void | Promise<void>;
}
export function HeaderMobileAuth(t0) {
  const $ = _c(11);
  const {
    isLoggedIn,
    displayName,
    hasActiveSubscription,
    onLogout
  } = t0;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  if (!isLoggedIn) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <LinkButton href="/login" className="flex items-center h-8" variant="default" size="sm" title={"\u067E\u0631\u0648\u0641\u0627\u06CC\u0644"}><span className="text-sm font-light">ورود </span></LinkButton>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsDropdownOpen(true);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button onClick={t1} className="flex items-center flex-col h-10 !rounded-full !p-0 h-8 w-11" variant="default" size="lg" title={"\u067E\u0631\u0648\u0641\u0627\u06CC\u0644"}><div className="flex items-center"><User size={24} /></div></Button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsDropdownOpen(false);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== displayName) {
    t4 = buildDropdownItems(displayName);
    $[4] = displayName;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== hasActiveSubscription || $[7] !== isDropdownOpen || $[8] !== onLogout || $[9] !== t4) {
    t5 = <>{t2}<DropdownMenu isOpen={isDropdownOpen} onClose={t3} items={t4} onLogout={onLogout} hasActiveSubscription={hasActiveSubscription} /></>;
    $[6] = hasActiveSubscription;
    $[7] = isDropdownOpen;
    $[8] = onLogout;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}